module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/164-croatia-e41a35b699c69910f33e1730bc6febf3.svg";